var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":_vm.viewEntries}},[_c('v-icon',[_vm._v("mdi-eye")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }